// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceDetailResponse

import { BillingInvoiceType, BillingInvoiceStatus } from './enums.gen';
import { hydrateBillingInvoiceLine, type BillingInvoiceLine, type BillingInvoiceLineApiResponse } from './billingInvoiceLine.gen';
import { hydrateBillingInvoiceItemPayment, type BillingInvoiceItemPayment, type BillingInvoiceItemPaymentApiResponse } from './billingInvoiceItemPayment.gen';
import { hydrateBillingInvoiceItemGuarantee, type BillingInvoiceItemGuarantee, type BillingInvoiceItemGuaranteeApiResponse } from './billingInvoiceItemGuarantee.gen';
import { hydrateBillingInvoicePayment, type BillingInvoicePayment, type BillingInvoicePaymentApiResponse } from './billingInvoicePayment.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingInvoiceDetailApiResponse = {
	id: number;
	invoiceNumber: string | null;
	type: BillingInvoiceType;
	status: BillingInvoiceStatus;
	paymentInProgress: boolean;
	date: string;
	amount: number;
	vatRate: number;
	vatAmount: number;
	totalAmount: number;
	creditAmount: number | null;
	netAmount: number;
	vatName: string | null;
	vatNotice: string | null;
	pdfUrl: string | null;
	lines: BillingInvoiceLineApiResponse[];
	itemPayments: BillingInvoiceItemPaymentApiResponse[];
	itemGuarantees: BillingInvoiceItemGuaranteeApiResponse[];
	payments: BillingInvoicePaymentApiResponse[];
	stripeInvoiceId: string | null;
	qontoInvoiceId: string | null;
	paidAt: string | null;
};

export type BillingInvoiceDetail = {
	id: number;
	invoiceNumber: string | null;
	type: BillingInvoiceType;
	status: BillingInvoiceStatus;
	paymentInProgress: boolean;
	date: DateTime;
	amount: number;
	vatRate: number;
	vatAmount: number;
	totalAmount: number;
	creditAmount: number | null;
	netAmount: number;
	vatName: string | null;
	vatNotice: string | null;
	pdfUrl: string | null;
	lines: BillingInvoiceLine[];
	itemPayments: BillingInvoiceItemPayment[];
	itemGuarantees: BillingInvoiceItemGuarantee[];
	payments: BillingInvoicePayment[];
	stripeInvoiceId: string | null;
	qontoInvoiceId: string | null;
	paidAt: DateTime | null;
};

export function hydrateBillingInvoiceDetail(data: BillingInvoiceDetailApiResponse): BillingInvoiceDetail {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		lines: data.lines.map(hydrateBillingInvoiceLine),
		itemPayments: data.itemPayments.map(hydrateBillingInvoiceItemPayment),
		itemGuarantees: data.itemGuarantees.map(hydrateBillingInvoiceItemGuarantee),
		payments: data.payments.map(hydrateBillingInvoicePayment),
		paidAt: DateTimefromISO(data.paidAt),
	};
}